import { dayjs } from "@saas/core/dayjs/dayjs";

export type FormatRemainingdaysInput = string | Date;

export type FormatRemainingdaysOutput = string;

export const formatRemainingDays = (
  input: FormatRemainingdaysInput
): FormatRemainingdaysOutput => {
  const days = dayjs(input);
  // If the days is in the past, return a simple message
  if (days.isBefore(dayjs())) return "0 Hari";

  const daysDiff = getDayDiff(days);
  return `${daysDiff} Hari`;
};
const getDayDiff = (dateTimes: dayjs.Dayjs): number => {
  return dateTimes.diff(dayjs(), "day");
};

export default formatRemainingDays;
